// Triveo — global entrypoint (loaded on every page)
//
//    <%= vite_client_tag %>
//    <%= vite_stylesheet_tag "application.css" %>  (Tailwind/daisyUI bundle)
//    <%= vite_javascript_tag "application" %>

import "../styles/app.css"
import "simplebar/dist/simplebar.css"

import SimpleBar from "simplebar"
import Alpine from "alpinejs"

// The original template exposes these as globals (loaded via CDN). Keep the
// same contract so the vendored scripts work unchanged.
window.SimpleBar = SimpleBar
window.Alpine = Alpine

// Start Alpine on DOMContentLoaded so per-component entrypoints (datatables,
// form-validation, …) have already registered their global x-data helpers.
// All module entrypoints evaluate before DOMContentLoaded fires.
window.addEventListener("DOMContentLoaded", () => Alpine.start())

// Layout customizer: theme / direction / font / sidebar behaviour.
import "../js/app.js"

// Máscaras de input (CEP, telefone, email minúsculo).
import "../js/masks.js"

// Confirmação de ações destrutivas em <dialog> (substitui o confirm() nativo).
import "../js/components/confirm-dialog.js"
import "../js/components/identity-preview.js"

// Acompanha a reprodução da aula (retomar, tempo corrente, envio da posição).
import "../js/components/learning-player.js"
import "../js/components/content-duration.js"

// Turbo Streams (notificações em tempo real) — Drive desligado (ver o módulo).
import "../js/turbo.js"

// O splash overlay foi removido: ele existia para mascarar o FOUC causado pelo
// @import do Google Fonts dentro do CSS. Agora a Inter é servida do próprio
// domínio (public/fonts) com <link rel="preload"> no <head>, então a fonte
// chega junto com a folha de estilo e não há flash a esconder.
